import { doRedirect } from 'utils/auth';

type CountdownConfig = {
  count: number;
  intervalId: NodeJS.Timer | undefined;
  onTick: (newCount: number) => void;
  redirectData:
    | {
        action?: string;
        location?: string;
      }
    | undefined;
  redirectToLoginPage: () => void;
};

export class Countdown {
  private readonly redirectToLoginPage: CountdownConfig['redirectToLoginPage'];

  private readonly onTick: CountdownConfig['onTick'];

  private redirectData: CountdownConfig['redirectData'];

  private intervalId: CountdownConfig['intervalId'];

  private count = 5;

  constructor({
    redirectToLoginPage,
    onTick
  }: {
    redirectToLoginPage: CountdownConfig['redirectToLoginPage'];
    onTick: CountdownConfig['onTick'];
  }) {
    this.redirectToLoginPage = redirectToLoginPage;
    this.onTick = onTick;
  }

  private _redirect() {
    const { location } = this.redirectData || {};
    if (location) {
      doRedirect(location);
      return;
    }
    this.redirectToLoginPage();
  }

  public setRedirectData(data: { action?: string; location?: string }): void {
    this.redirectData = data;
  }

  public start(count: number): void {
    this.count = count;
    const intervalId = setInterval(() => {
      const newCount = this.count - 1;
      if (newCount < 0) return;
      this.count = newCount;
      this.onTick(newCount);
      if (newCount === 0) {
        this.cleanup();
        this._redirect();
      }
    }, 1000);
    this.intervalId = intervalId;
  }

  public skipCountdown(): void {
    this.cleanup();
    this._redirect();
  }

  public cleanup(): void {
    clearInterval(this.intervalId);
  }
}
